module.exports = __webpack_public_path__ + "static/media/cool-products.a36ff3d8.webp";